import {
  getEventStudentList,
  getEventStudentMessageList,
  postEventStudentMessage,
  postEventLecturerMessage,
} from "@/services/event-student-message.service";

import { setPaginationDetails, formatMessageDate } from "../../utils/utils";

// initial state
const state = () => ({
  eventMessageModel: {
    file: [],
    EventsId: 0,
    Description: "",
  },
});

// mutations
const mutations = {
  setEventMessageModel(state, data) {
    state.eventMessageModel = data;
  },
};

// actions
const actions = {
  //Student List
  async loadEventStudentList(vuexContext, co) {
    return await getEventStudentList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((item, index) => {
        if (item.id === 0) item.id = index + 9999;
        item.index = index + 1;
        item.fullName = `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}`;
      });

      setPaginationDetails(co, totalCount, totalPages);

      return items;
    });
  },

  //Event Student Messages
  async loadEventStudentMessageList(vuexContext, data) {
    return await getEventStudentMessageList(data).then((response) => {
      let data = response.data.data;
      let items = data.items;
      items.map((item) => {
        item.addedTime = formatMessageDate(item.addedTime);
        if (item.userStudentDto) item.fullName = item.lecturer ? "Okutman" : item.userStudentDto.firstName + " " + item.userStudentDto.lastName;
      });
      return items;
    });
  },

  async postEventStudentMessage(vuexContext, data) {
    return await postEventStudentMessage(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async postEventLecturerMessage(vuexContext, data) {
    return await postEventLecturerMessage(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addEventMessageModel(vuexContext, data) {
    vuexContext.commit("setEventMessageModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
